import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "title" }

import CopyToClipboard from '@shell/components/Resource/Detail/CopyToClipboard.vue';
import Content from '@shell/components/Resource/Detail/Preview/Content.vue';
import { useBasicSetupFocusTrap } from '@shell/composables/focusTrap';
import { computed, onMounted, ref } from 'vue';

export interface Props {
  title: string;
  value: string;
  anchorElement: HTMLElement | null;
}


export default /*@__PURE__*/_defineComponent({
  ...{ inheritAttrs: false },
  __name: 'Preview',
  props: {
    title: {},
    value: {},
    anchorElement: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "e22a7c54": (right.value),
  "v2ac5678f": (top.value)
}))



const props = __props;
const emit = __emit;
const boundingRect = computed(() => props.anchorElement?.getBoundingClientRect());
const top = computed(() => `${ (boundingRect.value?.top || 0) - 28 }px`);
const right = computed(() => `${ (document.documentElement.clientWidth - (boundingRect.value?.left || 0)) + 16 }px`);
const containerRef = ref<HTMLElement | null>(null);
const escapePressed = ref(false);
const isMouseInteraction = ref(false);

const onFocusOut = (e: FocusEvent) => {
  // Refocus the container if the user clicks a child element (copy to clipboard)
  if (!escapePressed.value && containerRef.value?.contains(e.relatedTarget as Node)) {
    if (isMouseInteraction.value) {
      containerRef.value.focus();
    }
  } else {
    emit('close', escapePressed.value);
  }
};

const onKeydown = (event: KeyboardEvent) => {
  if (event.key === 'Escape') {
    escapePressed.value = true;
    containerRef.value?.blur();
  }
};

onMounted(() => {
  containerRef.value?.focus();
});

useBasicSetupFocusTrap('#focus-trap-preview-container-element');


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "#preview" }, [
    _createElementVNode("div", {
      id: "focus-trap-preview-container-element",
      ref_key: "containerRef",
      ref: containerRef,
      class: "preview",
      tabindex: "-1",
      onKeydown: onKeydown,
      onFocusout: onFocusOut,
      onMousedown: _cache[0] || (_cache[0] = ($event: any) => (isMouseInteraction.value=true)),
      onMouseup: _cache[1] || (_cache[1] = ($event: any) => (isMouseInteraction.value=false))
    }, [
      _createElementVNode("div", _hoisted_1, _toDisplayString(props.title), 1),
      _cache[2] || (_cache[2] = _createTextVNode()),
      _createVNode(Content, {
        class: "content",
        value: props.value
      }, null, 8, ["value"]),
      _cache[3] || (_cache[3] = _createTextVNode()),
      _createVNode(CopyToClipboard, {
        class: "copy-to-clipboard",
        value: props.value
      }, null, 8, ["value"])
    ], 544)
  ]))
}
}

})